export default "__VITE_ASSET__BXh$AWjs__"